import { useEffect, useMemo, useState } from 'react';
import {
  TDirectorInfo,
  TInfo,
  TStep3Branch,
  TStep3Info,
  TStep4Info,
  TStep5Info,
  TStep6Info,
} from '../types';
import axios from 'axios';
import {
  setInLocalStorageTrustee,
  getFromLocalStorageTrustee,
} from '../utils/setRegInfoInLocalStorage';
import { useAppDispatch } from '../app/hooks';
import { baseUrl_, timeout } from '../utils/constants';
import { decryptJson } from '../utils/decryptJson';
import { setAllPackages } from '../features/packages/packagesSlice';
import AboutBusiness from '../components/IncorporatedTruestees/AboutBusiness';
import BusinessName from '../components/IncorporatedTruestees/BusinessName';
import BusinessAddress from '../components/IncorporatedTruestees/BusinessAddres/BusinessAddress';
import ShareHolder from '../components/IncorporatedTruestees/ShareholderDetails/ShareHolder';
import Director from '../components/IncorporatedTruestees/Trustee/Trustee';
import Preview from '../components/IncorporatedTruestees/PreviewForm/Preview';
import SuccessModal from '../components/global/SuccessModal';
import { validateInputsResultOne } from '../utils/ValidateShareholderInfo';
import SideBar from '../components/IncorporatedTruestees/SideBar';
import { useCreateIncorperatedTrustee } from '../hooks/useCreateIncorperatedTrustee';
import { Request } from '../apis/request';

const getFormValues = (form: string, noOfDirectors?: number, noOfShareholders?: number) => {
  const storedValues = getFromLocalStorageTrustee(form);

  if (
    !storedValues &&
    !(
      form === 'branches-ltd' ||
      form === 'directors' ||
      form === 'shareholders' ||
      form === 'directors-in-shareholders' ||
      form === 'form5-ltd' ||
      form === 'shareholders-address' ||
      form === 'shareholders-docs' ||
      form === 'are-directors-shareholders'
    )
  ) {
    return {} as TInfo | TStep3Branch | TStep3Info | TStep4Info;
  } else if (
    !storedValues &&
    (form === 'branches-ltd' ||
      form === 'directors' ||
      form === 'shareholders' ||
      form === 'directors-in-shareholders')
  ) {
    return [];
  } else if (!storedValues && form === 'form5-ltd') {
    const arr = Array.from(Array(noOfDirectors).keys());
    const directorArr = arr.map(() => ({}));
    return directorArr;
  } else if (!storedValues && form === 'shareholders-address') {
    const arr = Array.from(Array(noOfShareholders).keys());
    const shareholdersArr = arr.map(() => ({}));
    return shareholdersArr;
  } else if (!storedValues && form === 'shareholders-docs') {
    const arr = Array.from(Array(noOfDirectors).keys());
    const arr2 = Array.from(Array(noOfShareholders).keys());
    const directorArr = arr.map(() => ({}));
    const shareArr2 = arr2.map(() => ({}));
    const finalArr = [...directorArr, ...shareArr2];
    return finalArr;
  } else if (!storedValues && form === 'are-directors-shareholders') {
    return '';
  }

  // DONT MIND ME
  const parsedStoreValue = storedValues && JSON.parse(JSON.stringify(storedValues));
  return parsedStoreValue;
};

const IncorporatedTrustees = () => {
  const [showAddForm, setShowAddForm] = useState(false);
  const [currentDirector, setCurrentDirector] = useState(-1);
  const [currentShareholder, setCurrentShareholder] = useState(0);
  const [directorsShareholders, setDirectorsShareholders] = useState<number[]>(
    getFormValues('directors-in-shareholders'),
  );
  const [step, setStep] = useState(1);
  const [step1, setStep1] = useState(getFormValues('form1-ltd'));

  const [areDirectorsShareholders, setAreDirectorsShareholders] = useState<string>(
    getFormValues('are-directors-shareholders'),
  );

  const [step3Info, setStep3Info] = useState<TStep3Info>(getFormValues('form3-ltd'));
  const [step3Branches, setStep3Branches] = useState<TStep3Branch[]>(getFormValues('branches-ltd'));

  const [directors, setDirectors] = useState<TDirectorInfo[]>(getFormValues('directors'));
  const [shareholders, setShareholders] = useState<TDirectorInfo[]>(getFormValues('shareholders'));
  const [shareholdersdocs, setShareholdersdocs] = useState<TStep6Info[]>(
    getFormValues('shareholders-docs', directorsShareholders.length, shareholders.length),
  );

  const [step5Info, setStep5Info] = useState<TStep5Info[]>(
    getFormValues('form5-ltd', directors.length, shareholders.length),
  );
  const [shareholderAddress, setShareholderAddress] = useState<TStep5Info[]>(
    getFormValues('shareholders-address', directors.length, shareholders.length),
  );
  const [showModal, setShowModal] = useState(false);
  const [currentBranch, setCurrentBranch] = useState(step3Branches?.length + 1);

  // display 2 means show the business address form without branches
  // display 1 means show the added branches
  // display 0 means show the business address form even with branches.lenght > 0
  const [display, setDisplay] = useState(2);

  const dispatch = useAppDispatch();

  useEffect(() => {
    const arr = Array.from(Array(directorsShareholders.length).keys());
    const arr2 = Array.from(Array(shareholders.length).keys());
    const directorArr = arr.map(() => ({}));
    const shareArr2 = arr2.map(() => ({}));
    const finalArr = [...directorArr, ...shareArr2];
    setShareholdersdocs(finalArr as TStep6Info[]);
  }, [directorsShareholders, shareholders]);

  useEffect(() => {
    setInLocalStorageTrustee({
      prop: 'are-directors-shareholders',
      value: areDirectorsShareholders,
    });
    if (areDirectorsShareholders === 'No') {
      setDirectorsShareholders([]);
    }
  }, [areDirectorsShareholders]);

  useEffect(() => {
    setInLocalStorageTrustee({ prop: 'form1-ltd', value: step1 });
  }, [step1]);

  useEffect(() => {
    setInLocalStorageTrustee({ prop: 'form3-ltd', value: step3Info });
  }, [step3Info]);

  useEffect(() => {
    setInLocalStorageTrustee({ prop: 'branches-ltd', value: step3Branches });
    // localStorage.setItem('branches-ltd', JSON.stringify(step3Branches));
  }, [step3Branches]);

  useEffect(() => {
    setInLocalStorageTrustee({ prop: 'directors', value: directors });
  }, [directors]);

  useEffect(() => {
    setInLocalStorageTrustee({ prop: 'form5-ltd', value: step5Info });
  }, [step5Info]);

  useEffect(() => {
    setInLocalStorageTrustee({ prop: 'shareholders', value: shareholders });
  }, [shareholders]);

  useEffect(() => {
    setInLocalStorageTrustee({ prop: 'shareholders-address', value: shareholderAddress });
  }, [shareholderAddress]);

  useEffect(() => {
    setInLocalStorageTrustee({ prop: 'directors-in-shareholders', value: directorsShareholders });
  }, [directorsShareholders]);

  useEffect(() => {
    setInLocalStorageTrustee({ prop: 'shareholders-docs', value: shareholdersdocs });
  }, [shareholdersdocs]);

  const benefits = [
    'Refrain from using popular names, names of states, cities and country',
    'Avoid hard to spell names. Keep it simple.',
    "Don't pick a name that could be limiting as your business grows.",
    'Conduct a thorough Internet search on the name to be sure no other person is using it.',
    'Assess and get feedback on your name. Is it catchy?',
    'Avoid using popular names, they most likely would have been taken.',
    'Bear in mind that you will still need to brand your name, so keep it simple, catchy and relevant.',
  ];

  useEffect(() => {
    Request.get(`/servicechargelogs/active`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('login-token')}`,
        sessId: localStorage.getItem('sessId') ?? '',
      },
      timeout: timeout,
    }).then((data) => {
      const res = decryptJson(data?.data?.data);
      dispatch(setAllPackages(res));
    });
  }, []);

  const getDirectorsInShareholder = useMemo(() => {
    const res = directorsShareholders?.map((no) => {
      return shareholders[no];
    });
    return res;
  }, [directorsShareholders, shareholders]);

  const { callCreateEntrepreneurMutation, loading } = useCreateIncorperatedTrustee({
    directors,
    directorsInShareholder: getDirectorsInShareholder,
    setShowModal,
    shareholders,
    step1,
    step3Branches: step3Branches as any,
  });
  const handleFinalSubmit = () => {
    callCreateEntrepreneurMutation();
  };

  const PageDisplay = () => {
    if (step === 1) {
      return <AboutBusiness step1={step1} setStep1={setStep1} setStep={setStep} step={step} />;
    } else if (step === 2) {
      return <BusinessName setStep={setStep} setStep1={setStep1} step1={step1} step={step} />;
    } else if (step === 3) {
      return (
        <BusinessAddress
          step3Info={step3Info}
          setStep={setStep}
          setStep3Info={setStep3Info}
          branches={step3Branches}
          setStep3Branches={setStep3Branches}
          currentBranch={currentBranch}
          setCurrentBranch={setCurrentBranch}
          display={display}
          setDisplay={setDisplay}
        />
      );
    } else if (step === 4) {
      return (
        <ShareHolder
          currentShareholder={currentShareholder}
          shareholders={shareholders}
          setShareholders={setShareholders}
          setCurrentShareholder={setCurrentShareholder}
          setStep={setStep}
        />
      );
    } else if (step === 5) {
      return (
        <Preview
          directors={directors}
          shareholders={shareholders}
          step1={step1}
          branches={step3Info}
          handleSubmit={handleFinalSubmit}
          loading={loading}
        />
      );
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const getText = (arr: TDirectorInfo[], currIndex: number, step: number) => {
    const completedFirstStep = validateInputsResultOne(arr, currIndex, step === 5);
    if (completedFirstStep) {
      return `${arr[currIndex]?.firstName} ${arr?.[currIndex]?.lastName} ${
        currIndex === 0 ? '(Chairman)' : currIndex === 1 ? '(Secretary)' : '(Member)'
      }`;
    } else if (currIndex + 1) {
      return step === 4 && `Trustee ${currIndex + 1} - details`;
    }
  };
  const topText: any = {
    1: `Tell us more about your Non Profit Organization`,
    2: `Provide 4 Preferred Names for the Organization in order of Preference`,
    3: `Provide headquater address`,
    4: getText(shareholders, currentShareholder, 4),
    5: `Make sure all information are correct`,
  };

  const steps = [
    'Nature of Organization',
    'Organization Names',
    'Organization Address',
    `Trustee’s Information`,
    // `Director's Information`,
  ];

  return (
    <>
      <div className='lg:flex lg:gap-[6vw]'>
        <SideBar
          active={1}
          steps={steps}
          step={step}
          instructions={
            step === 2
              ? [
                  `Refrain from using popular names, names of states, cities and country`,
                  `Avoid hard to spell names. Keep it simple.`,
                  `Don't pick a name that could be limiting as your business grows.`,
                  `Conduct a thorough Internet search on the name to be sure no other person is using it.`,
                  `Assess and get feedback on your name. Is it catchy?`,
                  `Avoid using popular names, they most likely would have been taken.`,
                  `Bear in mind that you will still need to brand your name, so keep it simple, catchy and relevant.`,
                ]
              : []
          }
          setStep={setStep}
          businessAddress={step === 3 ? step3Branches : []}
          shareholders={step === 4 ? shareholders : step === 5 ? directors : []}
          currentBranch={step === 3 ? currentBranch : 0}
          currentShareholder={step === 4 ? currentShareholder : step === 5 ? currentDirector : 0}
          display={display}
          handleClick={(index: number) => {
            if (step === 4) {
              setCurrentShareholder(index);
            } else {
              () => {
                // console.log("")
              };
            }
          }}
        />
        <div style={{ flex: 1 }}>
          <header className={`flex justify-center pt-[80px] w-full mx-auto`}>
            <div className='w-full'>
              {step === 1 && (
                <h2 className='text-[28px] leading-[42px] font-medium font-poppins mb-4'>
                  Lets get your business registered!
                </h2>
              )}
              {step < 6 && (
                <div className='text-[12px] font-poppins font-medium leading-[15px] mb-[6px] text-black '>
                  STEP {step} of 5
                </div>
              )}

              <div className='bg-[#F8B40042] rounded-[1.8px] inline-block pt-1 px-3 pb-1 mb-[5px] text-[black] text-[18px] font-[500] font-poppins leading-[24px] '>
                {step === 1
                  ? 'Structure of the Organization'
                  : step === 2
                  ? 'Names for the Organization'
                  : step === 3
                  ? `Business Address`
                  : step === 4
                  ? `Trustees Information`
                  : step === 5 && 'Preview your form'}
              </div>

              {step != 5 && (
                <div className='border-b-[1px] my-[18px] w-[80%] max-w-[348px] border-[#CDD5D5]'></div>
              )}
              {topText[step] && (
                <h2
                  className='mb-[27px] block p-[5px] rounded-sm text-[#005555]'
                  style={{ fontWeight: 500, fontSize: '19px', color: '#028789' }}
                >
                  {topText[step]}
                </h2>
              )}
            </div>
          </header>
          {PageDisplay()}
        </div>
      </div>

      <SuccessModal
        showSuccessModal={showModal}
        setShowSuccessModal={setShowModal}
        pageComingFrom={'Login'}
        description={`Your incorperated trustee registration form has been submitted and received`}
        proceedText={`PROCEED TO PAYMENT`}
      />
    </>
  );
};

export default IncorporatedTrustees;
